export const CATEGORIAS = [
    {id: 'gravado', name: 'Alcanzado'},
    {id: 'exento', name: 'Otras exenciones objetivas o subjetivas'},
    {id: 'regimen_simplificado', name: 'Monotributistas inscriptos en el Régimen Simplificado'},
]

export const PROVINCIAS = {
    "CIUDAD AUTÓNOMA DE BUENOS AIRES": "CABA",
}
